import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const useFixBrowserNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Store the current path in session storage on route changes
    sessionStorage.setItem("lastPath", location.pathname);

    // Handle initial page load or refresh
    const handleInitialLoad = () => {
      const lastPath = sessionStorage.getItem("lastPath");
      if (lastPath && window.location.pathname !== lastPath) {
        navigate(lastPath, { replace: true });
      }
    };

    // Run only once on component mount
    handleInitialLoad();

    // Listen for popstate events (browser back/forward buttons)
    const handlePopState = () => {
      // Allow the browser's native behavior to work
      // React Router will handle the route change automatically
    };

    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);

  // Don't add location.pathname as a dependency to avoid re-running on route changes
};

export default useFixBrowserNavigation;